var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43869 12.2073C7.01059 10.4377 8.11433 8.89806 9.59244 7.80795C11.0706 6.71783 12.8475 6.13297 14.6699 6.1368C16.7356 6.1368 18.6033 6.88687 20.0701 8.11448L24.3385 3.75034C21.7374 1.43138 18.4041 0 14.6699 0C8.88824 0 3.9109 3.3728 1.51758 8.31325L6.43869 12.2073Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6079 22.5157C18.2755 23.3945 16.5838 23.8633 14.6696 23.8633C12.8546 23.8671 11.0843 23.2869 9.60947 22.2048C8.13464 21.1228 7.02999 19.5936 6.45189 17.834L1.51367 21.6681C2.7253 24.1762 4.60039 26.2865 6.92594 27.7593C9.2515 29.2321 11.9343 30.0085 14.6696 30.0001C18.2547 30.0001 21.6797 28.6962 24.2454 26.2497L19.6091 22.5157H19.6079Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2447 26.2512C26.9277 23.691 28.6695 19.8806 28.6695 15.0002C28.6695 14.1126 28.5363 13.1588 28.3371 12.2725H14.6689V18.0692H22.5359C22.1484 20.0182 21.1057 21.527 19.6084 22.5171L24.2447 26.2512Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45039 17.8329C6.15135 16.919 5.99943 15.9614 6.00057 14.9977C6.00057 14.0201 6.15336 13.0813 6.43694 12.2037L1.51583 8.30957C0.509094 10.3881 -0.00987637 12.6781 0.000142346 14.9977C0.000142346 17.3979 0.54408 19.6606 1.51217 21.667L6.45039 17.8329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleWhite);
export default __webpack_public_path__ + "static/media/google-white.546b680ce421cacd318a3d4692f7815f.svg";
export { ForwardRef as ReactComponent };